import {
  clearEventDetails,
  fetchEventNameFail,
  fetchEventNameStarted,
  fetchEventNameSuccess
} from '../../../reducer/events/EventNameReducer';
import { getEventType } from '../../actionType/events/EventActionTypes';
import {
  ClearEvents,
  FetchEventFailure,
  FetchEventFailurePayload,
  FetchEventRequest,
  FetchEventStarted,
  FetchEventSuccess,
  FetchEventSuccessPayload
} from '../../types/events/FetchEventDetailTypes';

export const fetchEventRequest = (eventName: string, version: number): FetchEventRequest => ({
  type: getEventType.FETCH_EVENT_REQUEST,
  eventName,
  version
});

/**
 * Fetch event started saga action
 * @returns event started action
 */
export const fetchEventStarted = (): FetchEventStarted => ({
  type: fetchEventNameStarted.type
});

/**
 * Fetch event success saga action
 * @param payload :Event data
 * @returns success action
 */
export const fetchEventSuccess = (
  payload: FetchEventSuccessPayload
): FetchEventSuccess => ({
  type: fetchEventNameSuccess.type,
  payload
});

/**
 * Fetch Event Faild saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const fetchEventFailure = (
  payload: FetchEventFailurePayload
): FetchEventFailure => ({
  type: fetchEventNameFail.type,
  payload
});

/**
 * Clear Events saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const clearEvents = (): ClearEvents => ({
  type: clearEventDetails.type
});
